import React, { Component } from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { showIntercom } from "../../../lib/intercom";
import Divider from "../../lib/divider";
import "./support_page.scss";
import { withPageTitle } from "../../lib/WithPageTitle";

class SupportPage extends Component {
  componentDidMount() {
    showIntercom();
  }

  render() {
    return (
      <div className="support-page-container page-wrapper">
        <Grid fluid>
          <Row>
            <Col xs={12} md={6}>
              <h1 className="support-page__header">Support</h1>
              <Divider smallMargin className="margin-bottom--large" />
              <div className="support-page__description">
                Having trouble? Looking for advice? You can find support via the different options
                below.
              </div>
              <br />
              <h3>
                <span className="glyphicon glyphicon-education" />
                &nbsp;Help Articles
              </h3>
              <div className="support-page__description">
                Check out our <a href="https://support.redcircle.com">help articles</a> for guides
                on how to use the platform and on podcasting in general.
              </div>
              <h3>
                <span className="glyphicon glyphicon-user" />
                &nbsp;Chat
              </h3>
              <div className="support-page__description">
                We're available to chat live about whatever issues you're facing. Use the chat
                interface on the right to talk to our support staff.
              </div>
              <h3>
                <span className="glyphicon glyphicon-envelope" />
                &nbsp; Email
              </h3>
              <div className="support-page__description">
                You can always drop us an email at{" "}
                <a href="mailto:support@getredcircle.com">support@getredcircle.com</a> and someone
                will get back to you quickly.
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withPageTitle(SupportPage, "Support");
